import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import styles from "./TrendingBlogs.module.css";

function TrendingBlogs() {
  const [trendingBlogs, setTrendingBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchTrendingBlogs = async () => {
      try {
        setLoading(true);
        const apiUrl = process.env.REACT_APP_STRAPI_API_URL;
        const baseUrl = process.env.REACT_APP_STRAPI_BASE_URL;

        const response = await fetch(
          `${apiUrl}/articles?filters[category][slug][$eq]=trending&sort=publishedAt:desc&populate=*`,
          {
            headers: {
              Accept: "application/json",
            },
          },
        );

        if (!response.ok) {
          throw new Error("Failed to fetch trending blogs");
        }

        const result = await response.json();

        // Transform Strapi data to match component structure
        const transformedBlogs = result.data.map((article) => ({
          id: article.id,
          documentId: article.documentId,
          slug: article.slug,
          image: article.cover?.url
            ? `${baseUrl}${article.cover.url}`
            : "https://images.unsplash.com/photo-1542038784456-1ea8e935640e?w=800&q=80",
          title: article.title,
          date: new Date(article.publishedAt).toLocaleDateString("en-US", {
            year: "numeric",
            month: "long",
            day: "numeric",
          }),
        }));

        console.log(transformedBlogs);

        setTrendingBlogs(transformedBlogs);
        setError(null);
      } catch (err) {
        console.error("Error fetching trending blogs:", err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchTrendingBlogs();
  }, []);

  if (loading) {
    return (
      <div className={styles.trendingSection}>
        <div className={styles.loading}>Loading trending blogs...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className={styles.trendingSection}>
        <div className={styles.error}>
          Error loading trending blogs: {error}
        </div>
      </div>
    );
  }

  if (trendingBlogs.length === 0) {
    return (
      <div className={styles.trendingSection}>
        <h1 className={styles.trendingTitle}>
          Trending <span className={styles.fireEmoji}>🔥</span>
        </h1>
        <p className={styles.noBlogs}>No trending blogs at the moment.</p>
      </div>
    );
  }

  return (
    <div className={styles.trendingSection}>
      <h1 className={styles.trendingTitle}>
        Trending <span className={styles.fireEmoji}>🔥</span>
      </h1>

      <div className={styles.blogsGrid}>
        {trendingBlogs.map((blog) => (
          <Link
            key={blog.id}
            to={`/blogs/${blog.slug}`}
            className={styles.blogCard}
          >
            <div className={styles.imageContainer}>
              <img
                src={blog.image}
                alt={blog.title}
                className={styles.blogImage}
              />
            </div>
            <div className={styles.blogContent}>
              <h3 className={styles.blogTitle}>{blog.title}</h3>
              <p className={styles.blogDate}>{blog.date}</p>
              <span className={styles.readMore}>Read More</span>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}

export default TrendingBlogs;
